import React, { useEffect, useState } from "react";

// import { ChevronUpIcon } from "@heroicons/react/20/solid";
import speakerIcon from "../assets/images/icons8-speaker.png";
import { playAudio } from "../utils/btnAudio";
import { CButton } from "./CommonComponents";
const voiceSpeedRatio = {
  slow: {
    pitch: 1.0,
    rate: 0.7,
  },
  standard: {
    pitch: 1.2,
    rate: 1.0,
  },
  fast: {
    pitch: 1.5,
    rate: 1.5,
  },
};
const TextToSpeech = ({ displayedText }) => {
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState("");
  const [text, setText] = useState(displayedText);
  const [currentSpeed, setCurrentSpeed] = useState("standard");
  const [pitch, setPitch] = useState(voiceSpeedRatio?.standard?.pitch);
  const [rate, setRate] = useState(voiceSpeedRatio?.standard?.rate);
  const [chunks, setChunks] = useState([]);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isPaused, setIsPaused] = useState(false); // New state to track pause status
  const [currentChunkIndex, setCurrentChunkIndex] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const synth = window.speechSynthesis;
  const [synthState, setSynthState] = useState(synth);
  var utterThis;

  useEffect(() => {
    const cleanedParagraph = displayedText?.replace("**", "").replace("##", "");

    setText(cleanedParagraph);
    const sentences = cleanedParagraph.split(".");
    setChunks(sentences);
    return () => {
      synth.cancel();
      setIsSpeaking(false);
    };
  }, [displayedText]);

  useEffect(() => {
    const populateVoiceList = () => {
      const allVoices = synth.getVoices();
      console.log(allVoices, "alll");
      const englishVoices = allVoices.filter((voice) =>
        voice.lang.startsWith("en-US")
      );
      // const sliced = englishVoices?.slice(0, 5);
      // setVoices(sliced);

      const desiredVoices = allVoices.filter(
        (voice) =>
          // (voice.name === "Alex" ||
          // voice.name === "Fred" ||
          voice.name === "Samantha" &&
          // voice.name === "Victoria") &&
          voice.lang.startsWith("en-US")
      );
      setVoices(desiredVoices);
    };

    populateVoiceList();
    if (
      typeof speechSynthesis !== "undefined" &&
      speechSynthesis.onvoiceschanged !== undefined
    ) {
      speechSynthesis.onvoiceschanged = populateVoiceList;
    }

    // Cleanup function
    return () => {
      speechSynthesis.onvoiceschanged = null;
    };
  }, []);

  let abc = 0;
  const speakNextChunk = () => {
    if (currentChunkIndex < chunks.length) {
      utterThis = new SpeechSynthesisUtterance(displayedText);

      const selectedVoiceObj = voices.find(
        (voice) => voice.name === selectedVoice
      );
      if (selectedVoiceObj) {
        utterThis.voice = selectedVoiceObj;
      }
      utterThis.pitch = parseFloat(pitch);
      utterThis.rate = parseFloat(rate);

      setSynthState(utterThis);
      utterThis.onend = () => {
        abc = currentChunkIndex;
        setCurrentChunkIndex((prev) => prev + 1);
        speakNextChunk();
      };

      synth.speak(utterThis);
      setIsSpeaking(true);
    } else {
      setIsSpeaking(false);
    }
  };

  const speakRecipe = (event) => {
    playAudio();
    event.preventDefault();

    utterThis = new SpeechSynthesisUtterance(displayedText);

    const selectedVoiceObj = voices.find(
      (voice) => voice.name === selectedVoice
    );
    if (selectedVoiceObj) {
      utterThis.voice = selectedVoiceObj;
    }
    utterThis.pitch = parseFloat(pitch);
    utterThis.rate = parseFloat(rate);
    setSynthState(utterThis);
    synth.speak(utterThis);
    setIsSpeaking(true);
    setIsPaused(false);
    // setCurrentChunkIndex(0);
    // speakNextChunk();
  };

  const resumeAfterChange = (pitch, rate) => {
    // event.preventDefault();

    utterThis = new SpeechSynthesisUtterance(displayedText);
    const selectedVoiceObj = voices.find(
      (voice) => voice.name === selectedVoice
    );
    if (selectedVoiceObj) {
      utterThis.voice = selectedVoiceObj;
    }
    utterThis.pitch = parseFloat(pitch);
    utterThis.rate = parseFloat(rate);

    synth.speak(utterThis);
    setIsSpeaking(true);
    setIsPaused(false);
  };

  const handlePauseResume = () => {
    playAudio();
    if (synth.speaking) {
      if (synth.paused) {
        synth.resume();
        setIsPaused(false); // Update state when resumed
      } else {
        synth.pause();
        setIsPaused(true); // Update state when resumed
      }
    }
  };

  const handleStop = () => {
    if (synth.speaking) {
      synth.cancel();
      setIsSpeaking(false);
    }
  };

  const onSpeedButtonClick = async (speed) => {
    if (synth.speaking) {
      synth.pause();
      setPitch(voiceSpeedRatio[speed]?.pitch);
      setRate(voiceSpeedRatio[speed]?.rate);
      setCurrentSpeed(speed);

      // utterThis.pitch = parseFloat(voiceSpeedRatio[speed]?.pitch);
      // utterThis.rate = parseFloat(voiceSpeedRatio[speed]?.rate);
      // synth.resume();
      synth.cancel();

      setTimeout(() => {
        resumeAfterChange(
          voiceSpeedRatio[speed]?.pitch,
          voiceSpeedRatio[speed]?.rate
        );
      }, 3000);

      // setTimeout(() => {
      //   speakRecipe(); // Start a new speech with the updated settings
      // }, 1000);
    } else {
      setCurrentSpeed(speed);
      setPitch(voiceSpeedRatio[speed]?.pitch);
      setRate(voiceSpeedRatio[speed]?.rate);
    }
  };
  // const onSpeedButtonClick = (speed) => {
  //   if (synth.speaking) {
  //     setPitch(voiceSpeedRatio[speed]?.pitch);
  //     setRate(voiceSpeedRatio[speed]?.rate);
  //     setCurrentSpeed(speed);

  //     // Create a new utterance
  //     utterThis = new SpeechSynthesisUtterance(displayedText);
  //     const selectedVoiceObj = voices.find(
  //       (voice) => voice.name === selectedVoice
  //     );
  //     if (selectedVoiceObj) {
  //       utterThis.voice = selectedVoiceObj;
  //     }
  //     utterThis.pitch = parseFloat(pitch);
  //     utterThis.rate = parseFloat(rate);

  //     // Set up the onend event to resume speech
  //     utterThis.onend = () => {
  //       console.log("Speech ended, resuming...");
  //       speakRecipe();
  //     };

  //     // Cancel the current speech and start a new one after a delay
  //     synth.cancel();
  //     setTimeout(() => {
  //       synth.speak(utterThis);
  //       setIsSpeaking(true);
  //       setIsPaused(false);
  //     }, 1000); // Adjust the delay as needed
  //   } else {
  //     setCurrentSpeed(speed);
  //     setPitch(voiceSpeedRatio[speed]?.pitch);
  //     setRate(voiceSpeedRatio[speed]?.rate);
  //   }
  // };

  return (
    <>
      <div className="w-full  pt-4">
        <div className="flex  justify-start items-center w-full gap-4 flex-wrap">
          {!openPanel ? (
            <CButton
              onClick={() => {
                playAudio();
                setOpenPanel(true);
              }}
              variant="red"
              type="button"
              className="
          "
            // disabled={loading}
            >
              Listen to Recipe{" "}
              <img
                src={speakerIcon}
                alt={"speaker icon"}
                width={24}
                height={24}
                className="ml-2"
              />
            </CButton>
          ) : (
            <>
              <div className="flex items-center gap-2 ">
                {isSpeaking ? (
                  <>
                    {" "}
                    <CButton
                      type="button"
                      onClick={handlePauseResume}
                      variant="red"
                      className=""
                    // disabled={!isSpeaking}
                    >
                      {isPaused ? "Resume" : "Pause"}
                    </CButton>
                    <CButton
                      type="button"
                      variant="red"
                      onClick={() => {
                        playAudio();
                        handleStop();
                      }}
                      className=""
                    >
                      Stop
                    </CButton>
                  </>
                ) : (
                  <CButton
                    variant="red"
                    onClick={speakRecipe}
                    className=""
                  // disabled={loading}
                  >
                    Play <speakerIcon />
                  </CButton>
                )}
              </div>
              <div>
                <label>
                  <select
                    value={selectedVoice}
                    onChange={(e) => {
                      setSelectedVoice(e.target.value);
                      handleStop();
                    }}
                    className="p-1.5 w-[200px] rounded"
                  >
                    {voices?.map((voice, index) => (
                      <option key={voice.name} value={voice.name}>
                        {`${voice.name} (${voice.lang})`}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="flex items-center gap-4 flex-wrap">
                <CButton
                  variant={`${currentSpeed == "slow" ? "orange" : "red"}`}
                  type="button"
                  onClick={() => {
                    playAudio();
                    onSpeedButtonClick("slow");
                  }}
                  className=''
                // disabled={!isSpeaking}
                >
                  {"Slow"}
                </CButton>
                <CButton
                  variant={`${currentSpeed == "standard" ? "orange" : "red"}`}
                  type="button"
                  onClick={() => {
                    playAudio();
                    onSpeedButtonClick("standard");
                  }}
                  className=''
                >
                  {"Standard"}
                </CButton>
                <CButton
                  variant={`${currentSpeed == "fast" ? "orange" : "red"}`}
                  type="button"
                  onClick={() => {
                    playAudio();
                    onSpeedButtonClick("fast");
                  }}
                  className=''
                >
                  {"Fast"}
                </CButton>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default TextToSpeech;

{
  /* <div className="my-4 voice-range">
                      <label>
                        Pitch:
                        <input
                          type="range"
                          min="0.5"
                          max="2"
                          step="0.1"
                          value={pitch}
                          onChange={(e) => {
                            setPitch(e.target.value);
                            handleStop();
                          }}
                          className="mx-2 hover:outline-none"
                        />
                        {pitch}
                      </label>
                    </div>
                    <div>
                      <label>
                        Rate:
                        <input
                          type="range"
                          min="0.5"
                          max="3"
                          step="0.2"
                          value={rate}
                          onChange={(e) => {
                            setRate(e.target.value);
                            handleStop();
                          }}
                          className="mx-2"
                        />
                        {rate}
                      </label>
                    </div> */
}
